<template>
  <div v-if="hasNotList && !isLoading" class="search-body-tag">
    <ul class="search-body-tag-list dark-theme">
      <li v-for="(tag, index) in recommendList" :key="index">
        <a href="#" @click.prevent="goListPage(tag)">#{{ tag.text }}</a>
      </li>
    </ul>
  </div>
</template>
<script>
import { getRecommendList } from '@/common/utils/request'
import { CLOSE_SEARCH_POPUP_EVENT } from '@/common/resources/const'
import { sendEventLogSearchRecommendTag } from '@/common/utils/log.v2.send'
export default {
  name: 'SearchRecommendTagList',
  props: {
    totalCount: {
      type: Number
    },
    isLoading: {
      type: Boolean
    }
  },
  data () {
    return {
      recommendList: []
    }
  },
  methods: {
    setRecommendList () {
      getRecommendList().then(({ data }) => { this.recommendList = data })
    },
    goListPage (tag) {
      const { link, text } = tag
      const path = link
        .replace('https://www.wavve.com', '')

      sendEventLogSearchRecommendTag({ keyword: text, landingUrl: path })
      this.$router.push(path)
      this.$events.$emit(CLOSE_SEARCH_POPUP_EVENT)
    }
  },
  computed: {
    hasNotList () {
      return this.totalCount === 0
    }
  },
  created () {
    this.setRecommendList()
  }
}
</script>
